import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ClaimsPage } from '@/features/commercial/claims-page';

const searchSchema = z.object({
  tab: z.enum(['claims', 'notices', 'disputes']).optional().catch(undefined),
  claim: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/claims')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <ClaimsPage projectId={projectId} tab={search.tab} claim={search.claim} />;
}
